import styled from 'styled-components';

export const AttemptWrapper = styled.div`
  border-radius: 8px;
  padding: 9px 16px;
  background-color: ${({ theme }) => theme.colors.tone.lightRed};
  margin-top: 11px;
  margin-bottom: 16px;
`;

export const ModalContentWrapper = styled.div`
  form {
    margin-top: 16px;
  }
`;
